<template>
  <div>
    <generic-container
      v-bind:searchable="false"
      v-bind:show_plus="true"
      icon="list"
      :title="$t('team list')"
      v-on:add="add"
      :header_buttons="header_buttons"
    >
      <table
        class="ui blue very compact celled striped selectable table"
        ref="table"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>{{ $t("name") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-container>
  </div>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { init_ajax_data_datables, local_api, error_toast } from "@/utils";

export default {
  name: "MultimoneyStaffConfigurationModalTeam",
  components: {
    "generic-container": GenericContainer,
  },
  props: {},
  data() {
    return {
      list: [],
      header_buttons: [{ icon: "refresh", click: this.init_datatable }],
    };
  },
  methods: {
    add() {
      let vm = this;
      vm.$alertify.prompt(vm.$t("new team name"), "", function (e, comment) {
        local_api(vm, "post", "/multimoney_staff/configuration/team/do-save", {
          n: comment,
        })
          .then(() => {
            vm.init_datatable();
          })
          .catch((err) => {
            error_toast(err);
          });
      });
    },
    destroy() {
      this.graphic_card_modals = [];
      this.selected_card = undefined;
    },
    succedded() {
      this.init_datatable();
      this.destroy();
    },
    init_datatable() {
      let vm = this;
      let columns = [
        {
          data: function (row) {
            return row.name;
          },
        },
      ];

      let onSelect = (data) => {
        vm.$alertify.prompt(
          vm.$t("team name"),
          data.name,
          function (e, comment) {
            local_api(
              vm,
              "post",
              "/multimoney_staff/configuration/team/do-save",
              {
                u: data.uuid,
                n: comment,
              },
            )
              .then(() => {
                vm.init_datatable();
              })
              .catch((err) => {
                error_toast(err);
              });
          },
        );
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["multimoney staff team url"],
        columns,
        onSelect,
      );
    },
  },
  mounted() {
    let vm = this;
    vm.init_datatable();
  },
};
</script>
